import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  max-width: 900px;
  margin: 0 auto;
  padding: 0;
  
  @media screen and (max-width: 820px) {
    width: 100%;
  }
  
  .header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 40px;
    padding-bottom: 20px;
    border-bottom: 2px solid #e3f2fd;
    
    .texts {
      h3 {
        font-size: 36px;
        line-height: 48px;
        color: #1a237e;
        font-weight: 700;
        margin-bottom: 8px;
        background: linear-gradient(135deg, #03a9f4 0%, #0288d1 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
      }
      p {
        margin-top: 5px;
        line-height: 22px;
        font-size: 16px;
        color: #546881;
      }
    }
  }
  
  .submit {
    margin-top: 40px;
    padding-top: 30px;
    border-top: 2px solid #e3f2fd;
    display: flex;
    justify-content: flex-end;
    
    .submit-buttons {
      display: flex;
      gap: 12px;
      
      .cancel,
      .add-campaign {
        padding: 12px 24px;
        height: 44px;
        border-radius: 10px;
        font-size: 14px;
        font-weight: 500;
        background-color: transparent;
        text-decoration: none;
        cursor: pointer;
        transition: all 0.3s ease;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      
      .cancel {
        color: #546881;
        border: 2px solid #e3f2fd;
        
        &:hover {
          border-color: #03a9f4;
          color: #03a9f4;
        }
      }
      
      .add-campaign {
        color: #fff;
        border: 2px solid #03a9f4;
        background: linear-gradient(135deg, #03a9f4 0%, #0288d1 100%);
        box-shadow: 0 2px 8px rgba(3, 169, 244, 0.3);
        
        &:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 16px rgba(3, 169, 244, 0.4);
        }
        
        &:disabled {
          opacity: 0.6;
          cursor: not-allowed;
          transform: none;
        }
      }
    }
  }
`;

export const FormWrapper = styled.div`
  margin-bottom: 30px;
  padding: 25px 0;
  border-bottom: 1px solid #e3f2fd;
  
  &:last-of-type {
    border-bottom: none;
  }
  
  /* Grid layout for 3 columns */
  &.grid-row-3 {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 24px;
    align-items: start;
    
    @media screen and (max-width: 1024px) {
      grid-template-columns: repeat(2, 1fr);
    }
    
    @media screen and (max-width: 768px) {
      grid-template-columns: 1fr;
      gap: 20px;
    }
  }
  
  /* Full width layout */
  &.full-width {
    display: block;
  }
  
  label {
    display: block;
    margin-bottom: 10px;
    color: #1a237e;
    font-size: 14px;
    font-weight: 600;
  }
  
  p {
    margin-top: 5px;
    margin-bottom: 15px;
    font-size: 13px;
    color: #546881;
    line-height: 1.5;
  }

  input[type="text"],
  input[type="file"],
  input[type="date"],
  input[type="number"] {
    width: 100%;
    margin-top: 10px;
    border: 2px solid #e3f2fd;
    border-radius: 10px;
    padding: 12px 16px;
    font-size: 14px;
    color: #1a237e;
    background: #ffffff;
    transition: all 0.3s ease;
    
    &:focus {
      outline: none;
      border-color: #03a9f4;
      box-shadow: 0 0 0 3px rgba(3, 169, 244, 0.1);
    }
    
    &::placeholder {
      color: #98a2b3;
    }
  }
  
  /* Field wrapper for grid items */
  .field-group {
    display: flex;
    flex-direction: column;
  }
`;

export const InputWrapper = styled.div`
  position: relative;
  margin-top: 10px;
  width: 100%;
  
  input {
    width: 100%;
    border: 2px solid #e3f2fd;
    border-radius: 10px;
    padding: 12px 16px;
    font-size: 14px;
    color: #1a237e;
    background: #ffffff;
    transition: all 0.3s ease;
    
    &:focus {
      outline: none;
      border-color: #03a9f4;
      box-shadow: 0 0 0 3px rgba(3, 169, 244, 0.1);
    }
  }
`;

export const Tooltip = styled.div`
  position: absolute;
  top: -90px;
  left: 0;
  background: #ffffff;
  border: 2px solid #03a9f4;
  border-radius: 10px;
  padding: 12px 16px;
  font-size: 13px;
  color: #1a237e;
  box-shadow: 0 4px 12px rgba(3, 169, 244, 0.2);
  white-space: nowrap;
  z-index: 10;
  min-width: 200px;
  
  &::after {
    content: "";
    position: absolute;
    top: 100%;
    left: 20px;
    border: 8px solid transparent;
    border-top-color: #03a9f4;
  }
  
  strong {
    display: block;
    font-weight: 600;
    margin-bottom: 6px;
    color: #03a9f4;
  }
  
  p {
    margin: 0;
    font-size: 12px;
    color: #546881;
    line-height: 1.5;
  }
`;
